import { galleryConstants } from '../constants'

const initialState = {
  list: null
}

export default function gallery(state = initialState, action) {
  switch (action.type) {
    case galleryConstants.GALLERY_UPDATE:
      return {
        ...state,
        list: (state.list === null
          ? [action.payload]
          : state.list.findIndex((x) => x.id === action.payload.id) === -1
          ? state.list.concat(action.payload)
          : state.list.map((item) => {
              return item.id === action.payload.id ? action.payload : item
            })
        ).sort((a, b) => (a.order === b.order ? 0 : a.order ? -1 : 1))
      }
    case galleryConstants.GALLERY_REMOVE:
      return {
        ...state,
        list: state.list
          .filter((item) => {
            return item.id !== action.payload.id
          })
          .sort((a, b) => (a.order === b.order ? 0 : a.order ? -1 : 1))
      }
    default:
      return state
  }
}
